import actions from './actions';

const initialState = {
    compras: [],
    compraPasadaAPagar: {}
};

export default function cajaReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_COMPRAS_SUCCESS:
            return {
                ...state,
                compras: action.payload,
            }
        case actions.PASS_TO_PAY:
            return {
                ...state,
                compraPasadaAPagar: action.payload,
            }
        default:
            return state;
    }

}
